import { render, staticRenderFns } from "./FlightLuggageOptionDetails.vue?vue&type=template&id=716f5ab2&scoped=true&"
import script from "./FlightLuggageOptionDetails.vue?vue&type=script&lang=js&"
export * from "./FlightLuggageOptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f5ab2",
  null
  
)

/* custom blocks */
import block0 from "./FlightLuggageOptionDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
